<template>
    <div>
        <v-row>
            <v-col cols="12">
                <v-btn color="primary" text rounded @click="$root.goTo($root.route('roles.index'))">
                    {{ t('default::button.cancel') }}
                </v-btn>
                <v-btn
                    v-if="can('api.v1.auth.change-password')"
                    class="ml-4"
                    color="primary"
                    rounded
                    :disabled="readOnlyRules"
                    :loading="dmsRoleFormLoading"
                    @click="saveDmsRole()"
                >
                    {{ t('dms-users::button.save') }}
                </v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    data() {
        return {
            dmsRoleFormLoading: false,
        };
    },
    computed: {
        id() {
            return this.$store.state.dms_roles.dms_role.id;
        },
        readOnlyRules() {
            return !this.can('api.v1.roles.update') || this.$store.state.dms_roles.dms_role.readonly;
        },
    },
    methods: {
        saveDmsRole() {
            this.dmsRoleFormLoading = true;
            this.$store.dispatch('dms_users/resetErrorMessages');
            axios({
                method: this.id ? 'put' : 'post',
                url: this.id ? route('api.v1.roles.update', { role: this.id }) : route('api.v1.roles.store'),
                data: this.$store.state.dms_roles.dms_role,
            })
                .then(() => {
                    if (this.id) {
                        this.$root.notify('info', t('default::notification.success'), t('roles::notification.update'));
                    }

                    if (!this.id) {
                        this.$root.notify('info', t('default::notification.success'), t('roles::notification.create'));
                    }
                    _.delay(() => {
                        this.$root.goTo(route('roles.index'));
                    }, 1000);
                })
                .catch((error) => {
                    if (error.response && error.response.status === 422) {
                        this.$store.dispatch('dms_roles/setErrorMessages', error.response.data.errors);
                    } else {
                        this.$root.notify('error', error.response.data.error);
                    }
                })
                .finally(() => _.delay(() => (this.dmsRoleFormLoading = false), 400));
        },
    },
};
</script>

<style></style>
